module.exports = __webpack_public_path__ + "Healthy.a74850d1683fe0929674b5c75449b085.hashedasset.svg";